<ng-container *ngIf="pageText | async as data">
    <div [innerHTML]="data.contents"></div>
</ng-container>